import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import AskAboutProductForm from 'Component/AskAboutProductForm';
import CmsBlock from 'Component/CmsBlock';
import Icons from 'Component/Icons';
import {
    ASK_QUESTION_DRAWER,
    SHIPPING_COST_DRAWER,
    SHIPPING_COST_DRAWER_CMS,
    SHIPPING_TIME_DRAWER,
    SHIPPING_TIME_DRAWER_CMS,
} from 'Component/ProductAdditionalInfo/ProductAdditionalInfo.config';
import { PRODUCT_TABS_FIRST_GROUP, SCROLL_TO_TAB_OFFSET } from 'Component/ProductTabs/ProductTabs.config';
import SideDrawer from 'Component/SideDrawer';
import TypographyHeader from 'Component/TypographyHeader';

import './ProductAdditionalInfo.style';

/** @namespace Advox/Component/ProductAdditionalInfo/Component */
export class ProductAdditionalInfo extends PureComponent {
    static propTypes = {
        calculatedDeliveryTime: PropTypes.string.isRequired,
        calculatedDeliveryCost: PropTypes.string.isRequired,
        phone: PropTypes.string.isRequired,
        openedDrawer: PropTypes.string,
    };

    static defaultProps = {
        openedDrawer: null,
    };

    drawerMap = {
        [SHIPPING_COST_DRAWER]: {
            title: __('Shipping'),
            content: ({ calculatedDeliveryCost: cost }) => (
                <div block="ProductAdditionalInfo" elem="Drawer">
                    {cost && cost !== '' ? (
                        <TypographyHeader variant="small" tag="h4">
                            {__('We will carry out your delivery from %s!', cost)}
                        </TypographyHeader>
                    ) : null}
                    <CmsBlock identifier={SHIPPING_COST_DRAWER_CMS} />
                </div>
            ),
        },
        [SHIPPING_TIME_DRAWER]: {
            title: __('Shipping'),
            content: ({ calculatedDeliveryTime: time }) => (
                <div block="ProductAdditionalInfo" elem="Drawer">
                    {time && time !== '' ? (
                        <TypographyHeader variant="small" tag="h4">
                            {__('Delivery time: %s!', time)}
                        </TypographyHeader>
                    ) : null}

                    <CmsBlock identifier={SHIPPING_TIME_DRAWER_CMS} />
                </div>
            ),
        },
        [ASK_QUESTION_DRAWER]: {
            title: __('Ask for product'),
            content: ({ closeDrawer }) => <AskAboutProductForm closeDrawer={closeDrawer} />,
        },
    };

    render() {
        const {
            calculatedDeliveryTime,
            calculatedDeliveryCost,
            openedDrawer,
            closeDrawer,
            openDrawer,
            phone,
            showAlternativeDesign,
        } = this.props;
        const drawerData = openDrawer ? this.drawerMap[openedDrawer] : null;

        return (
            <div block="ProductAdditionalInfo" mods={{ alternative: showAlternativeDesign }}>
                <div block="ProductAdditionalInfo" elem="Item" onClick={() => openDrawer(SHIPPING_TIME_DRAWER)}>
                    <div block="ProductAdditionalInfo" elem="Icon">
                        <Icons name="clock_2" width="24" height="24" fill="#63B69E" />
                    </div>
                    <div block="ProductAdditionalInfo" elem="Text">
                        <div>{__('Delivery time:')}</div>
                        <div>
                            {calculatedDeliveryTime && calculatedDeliveryTime !== ''
                                ? calculatedDeliveryTime
                                : __('No data')}
                        </div>
                    </div>
                    <div block="ProductAdditionalInfo" elem="Angle">
                        <Icons name="angle_right" width="12" height="12" fill="#000" />
                    </div>
                </div>
                <div block="ProductAdditionalInfo" elem="Item" onClick={() => openDrawer(SHIPPING_COST_DRAWER)}>
                    <div block="ProductAdditionalInfo" elem="Icon">
                        <Icons name="truck_2" width="24" height="24" fill="#63B69E" />
                    </div>
                    <div block="ProductAdditionalInfo" elem="Text">
                        <div>{__('Shipping cost:')}</div>
                        <div>
                            {calculatedDeliveryCost && calculatedDeliveryCost !== ''
                                ? calculatedDeliveryCost
                                : __('Ask for product')}
                        </div>
                    </div>
                    <div block="ProductAdditionalInfo" elem="Angle">
                        <Icons name="angle_right" width="12" height="12" fill="#000" />
                    </div>
                </div>
                <a href={`tel:${phone}`} block="ProductAdditionalInfo" elem="Item">
                    <div block="ProductAdditionalInfo" elem="Icon">
                        <Icons name="phone_2" width="24" height="24" fill="#63B69E" />
                    </div>
                    <div block="ProductAdditionalInfo" elem="Text">
                        <div>{__('Make order:')}</div>
                        <div>{phone}</div>
                    </div>
                </a>
                <div block="ProductAdditionalInfo" elem="Item" onClick={() => openDrawer(ASK_QUESTION_DRAWER)}>
                    <div block="ProductAdditionalInfo" elem="Icon">
                        <Icons name="envelope" width="24" height="24" fill="#63B69E" />
                    </div>
                    <div block="ProductAdditionalInfo" elem="Text">
                        <div>{__('Have question?')}</div>
                        <div>{__('Ask for product')}</div>
                    </div>
                    <div block="ProductAdditionalInfo" elem="Angle">
                        <Icons name="angle_right" width="12" height="12" fill="#000" />
                    </div>
                </div>
                {showAlternativeDesign ? (
                    <div
                        block="ProductAdditionalInfo"
                        elem="Item"
                        onClick={() => {
                            const tabs = document.getElementById(PRODUCT_TABS_FIRST_GROUP);
                            const { top } = tabs.getBoundingClientRect();

                            window.scrollTo({ top: top + window.scrollY - SCROLL_TO_TAB_OFFSET, behavior: 'smooth' });
                        }}
                    >
                        <div block="ProductAdditionalInfo" elem="Icon">
                            <Icons name="box" width="24" height="24" fill="#63B69E" />
                        </div>
                        <div block="ProductAdditionalInfo" elem="Text">
                            <div>{__('Technical details and description')}</div>
                        </div>
                        <div block="ProductAdditionalInfo" elem="Angle">
                            <Icons name="angle_right" width="12" height="12" fill="#000" />
                        </div>
                    </div>
                ) : null}

                <SideDrawer
                    title={drawerData ? drawerData.title : ''}
                    closeDrawer={closeDrawer}
                    isOpen={!!openedDrawer}
                >
                    {drawerData
                        ? drawerData.content({ calculatedDeliveryTime, calculatedDeliveryCost, closeDrawer })
                        : null}
                </SideDrawer>
            </div>
        );
    }
}

export default ProductAdditionalInfo;
